import { render, staticRenderFns } from "./JourneyGap.vue?vue&type=template&id=5b407f0b&scoped=true"
import script from "./JourneyGap.vue?vue&type=script&lang=js"
export * from "./JourneyGap.vue?vue&type=script&lang=js"
import style0 from "./JourneyGap.vue?vue&type=style&index=0&id=5b407f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b407f0b",
  null
  
)

export default component.exports